import Started from "containers/Game/Started";
import { actions } from "core/constants";
import { processText } from "core/utils/string";
import React from "react";
import { web } from "submodules/sharedText/flavor";

const { VOTE_TO_KILL } = actions;

const { day } = web;

const Day = ({
  player,
  socket,
  role,
  image,
  isExpired,
  playerVoted,
  message,
  gameSessionId,
  currentEvent,
}) => {
  const { candidates, id: playerId } = player || {};

  const confirmVote = (_playerVote) => {
    socket.emit(VOTE_TO_KILL, {
      gameSessionId,
      playerId,
      vote: _playerVote,
      confirm: true,
    });
  };

  // TODO: Sort self to front
  const options = candidates?.map(({ id, userName }) => {
    return {
      text: userName,
      onClick: () => confirmVote(id),
    };
  });

  return (
    <Started
      dataTestId="day-phase"
      title={processText(day.title)}
      content={message || processText(day.content.default[role])}
      role={role}
      image={image}
      isExpired={isExpired}
      isLoading={playerVoted}
      options={!playerVoted ? options : []}
      currentEvent={currentEvent}
    />
  );
};
export default Day;
